"use client";
import React from "react";
import Link from "next/link";
import DynamicImage from "@/components/DynamicImages/DynamicImage";
import contact_pinned from "@/assets/images/static/contact_pinned.webp";
import needShoppingHelpIcon from "@/assets/images/NeedShoppingHelpIcon.webp";
import GaggenauBannerWeb from "@/assets/images/static/brands/Gaggenau/GaggenauCombiMicrowaveCookingDemoSJBanner_web.png"
import GaggenauBannerMobile from "@/assets/images/static/brands/Gaggenau/GaggenauCombiMicrowaveCookingDemoSJBanner_mobile.png"

import Image from "next/image";
import { allBrandList } from "@/components/BrandDetail/arraybrandlist";

const Banner = ({ brandName }) => {
  const DataResponse = allBrandList.find((item,index) => item[brandName])?.[
    brandName
  ];

  if (!DataResponse) {
    return (
      <div className="max-w-[1480px] mx-auto my-0 py-14 px-5 lg:py-11  pb-[40px] ">
        <h2 class=" text-[21px] leading-[31px] font-bold text-blue2 text-center lg:text-[16px] lg:leading-[22px] lg:mb-[27px]">
          Data not found.
        </h2>
      </div>
    );
  }

  return (
    <div>
      <div className=" relative pb-[20.8%] xl:pb-0 xl:h-[295px] smd:h-[200px] mob:h-[150px]">
        <Image
            src={DataResponse.BannerData.bannerImg}
            alt="banner"
            fill
            className="object-cover"
          />
         
          {brandName === "Thermador" && 
             <div className="w-full h-full flex items-center justify-center bg-black/10 absolute top-0 left-0 z-9">
             <div className="w-auto flex flex-col self-center justify-center">
             <h5 className="text-center text-white uppercase text-[20px] mb-[6px] font-semibold smd:text-[16px]">Thermador</h5>
             <h1 className="text-center text-white text-[45px] leading-[49px] uppercase font-medium smd:text-[32px] smd:leading-[35px]">LEAP INTO LUXURY</h1>
             <div className="flex justify-center my-5 smd:my-[10px]">
                <Link className="bg-white smd:text-[14px] text-[#0c2340] opacity-99 w-auto h-auto px-[20px] py-[9px] border-0 no-underline rounded-full text-center" href="/leap-into-luxury" rel="noopener" data-uw-rm-brl="PR" data-uw-original-href="https://www.airportappliance.com/leap-into-luxury" aria-label="View Packages - open in a new tab" data-uw-rm-ext-link="" uw-rm-external-link-id="https://www.airportappliance.com/leap-into-luxury$viewpackages">View Packages</Link></div>
             </div>
             </div>
          }
      </div>
      <div className="py-[50px] container max-w-1440 px-5  ">
        <div className=" flex justify-between gap-2 w-full slg:flex-col slg:gap-4 1070:flex-col 1070:gap-6 ">
          <div className="grid grid-cols-[auto_1fr] gap-[62px] md:flex-col md:gap-4 items-center lg:gap-[40px] slg:grid-cols-1 slg:gap-[20px]">
                <DynamicImage
                src={DataResponse.BannerData.logoImg}
                alt="banner"
                className=" object-contain h-auto lg:max-w-[80%] slg:max-w-[60%] slg:m-[0_auto]"
              />
            <div className="pl-[62px] border-l md:pl-0 md:border-none lg:pl-[40px] slg:pl-0 slg:border-l-0 slg:flex slg:flex-col slg:justify-center slg:text-center slg:items-center">
              <p className="text-[36px] font-semibold mb-4 leading-[40px] smd:text-[28px] smd:leading-[33px] smd:mb-2">
                {DataResponse.BannerData.subheading}
              </p>
              <p className={brandName === "Bertazzoni" || brandName ==="Lg_Studio"? "text-[16px] text-[#374151] max-w-[700px]": "text-[16px]  text-[#374151] max-w-[528px]"}>
                 {DataResponse.BannerData.descriptionTxt}
              </p>
              {brandName === "Gaggenau" &&  <p className={"text-[16px] text-blue5 max-w-[700px] mt-2"}>
               Note: Gaggenau products are available to purchase only at our in-store locations. Please contact store directly for details.
              </p>}
            </div> 
          </div>
          <div className="min-w-[185px] slg:flex slg:justify-center slg:items-end slg:gap-3 slg:flex-wrap">
            <div className="flex gap-4 mb-5 slg:w-[211px] slg:mb-0">
              <div className="w-[45px] h-[45px] overflow-hidden">
                <DynamicImage
                  src={needShoppingHelpIcon}
                  className="w-full h-full object-cover"
                  alt="Airport Home Appliance Logo"
                />
              </div>
              <div className=" text-[14px]">
                <p className=" font-medium ">Need shopping help?</p>
                <Link 
                  href="tel:+18663044449" 
                  aria-label="call +18663044449"  
                  className="text-blue5  underline cursor-pointer">
                 Ask a Specialist
                </Link>{" "}
              </div>
            </div>
            <div className="flex gap-4 slg:w-[211px]">
              <div className="w-[45px] h-[45px] overflow-hidden">
                <DynamicImage
                  src={contact_pinned}
                  className="w-full h-full object-cover"
                  alt="Airport Home Appliance Logo"
                />
              </div>
              <div className=" text-[14px]">
                <p className=" font-medium ">Visit a Showroom</p>
                <Link href={"/stores"} className="text-blue5  underline cursor-pointer">
                 Find a store
                </Link>
              </div>
            </div>
          </div>
        </div>
       
        {/* {brandName === "Gaggenau" && <Link href="/events/gaggenau-combi-microwave-oven-demo-san-jose">
          <div className="mt-5 max-w-[1200px] mx-auto">
          <Image src={GaggenauBannerWeb} alt="Gaggenau_banner" className="md:hidden"/>
          <Image src={GaggenauBannerMobile} alt="Gaggenau_banner" className="md:block hidden" />
        </div>
          </Link>
        } */}
        
      </div>
    </div>
  );
};

export default Banner;